module.exports = __webpack_public_path__ + "img/147-Beige Croe.jpg";